import GetProductsMapper from './DXP/GetProductsMapper'
import GetPricingMapper from './MID/GetPricingMapper'
import SavePetsMapper from './MID/SavePetsMapper'
import SavePetsQuotationMapper from './MID/SavePetsQuotationMapper'

export default {
  GetProductsMapper,
  GetPricingMapper,
  SavePetsMapper,
  SavePetsQuotationMapper
}
